export const kuralData = [
  {
    id: 1,
    theme: "Education",

    tamil: [
      "கற்க",
      "கசடறக்",
      "கற்பவை",
      "கற்றபின்",
      "நிற்க",
      "அதற்குத்",
      "தக",
    ],

    english: [
      {
        word: "karka",
        variants: ["Karka", "Karkaah", "Karkae", "Karkka", "Karga", "Garka"]
      },
      {
        word: "kasadara",
        variants: ["Kasadara", "Kasathara", "Kasadaraa", "Kasatharaa", "Gasadara"],
      },
      {
        word: "karpavai",
        variants: ["Karpavai", "Karppavai", "Karpavaiy", "Karpavay", "Karpavei", "Garbavai"],
      },
      {
        word: "katrapin",
        variants: ["Katrapin", "Katrappin", "Katrapinn", "Katrabin", "Gatrapin", "Kathrapin"],
      },
      {
        word: "nirka",
        variants: ["Nirka", "Nirkaa", "Nirga", "Nirkah", "Nirkka"],
      },
      {
        word: "atharkku",
        variants: ["Atharkku", "Adharkku", "Atharku", "Adharku", "Atharukku", "Atharkkoo"],
      },
      {
        word: "thaga",
        variants: ["Thaga", "Dhaga", "Thagha", "Thaaga", "Dhagaa", "Taga"],
      },
    ],

    englishMeaning:
      "Learn perfectly what is worth learning, and then live by what you have learned.",

    blanks: [0, 1, 2, 3, 4, 5, 6],
  },

  {
    id: 2,
    theme: "Friendship",

    tamil: [
      "முகநக",
      "நட்பது",
      "நட்பன்று",
      "நெஞ்சத்து",
      "அகநக",
      "நட்பது",
      "நட்பு",
    ],

    english: [
      {
        word: "muganaga",
        variants: ["Muganaga", "Muganagha", "Muganaka", "Muganagaa", "Muganagga", "Mukanaga"],
      },
      {
        word: "natpadu",
        variants: ["Natpadu", "Nadpadu", "Natpadhu", "Nadpadhu", "Natpaadu", "Natpatu"],
      },
      {
        word: "natpanru",
        variants: ["Natpanru", "Nadpanru", "Natpanroo", "Natpanruu", "Natbanru", "Nadbanru"],
      },
      {
        word: "nenjaththu",
        variants: ["Nenjaththu", "Nenjathu", "Nenjatthu", "Nenjadhu", "Nenjathoo", "Nenjathuu"],
      },
      {
        word: "aganaga",
        variants: ["Aganaga", "Aganagha", "Aganaka", "Aganagaa", "Akanaga", "Aghanaga"],
      },
      {
        word: "natpadhu",
        variants: ["Natpadhu", "Nadpadhu", "Natpadu", "Nadpadu", "Natpaadhu", "Natpathu"],
      },
      {
        word: "natpu",
        variants: ["Natpu", "Nadpu", "Natboo", "Natphu", "Nathpu", "Natpoo"],
      },
    ],

    englishMeaning:
      "Friendship that shows only a smile on the face is not real friendship. True friendship is when the heart smiles from within.",

    blanks: [0, 1, 2, 3, 4, 5, 6],
  },

  {
    id: 3,
    theme: "Time",

    tamil: [
      "காலம்",
      "கருதி",
      "இருப்பர்",
      "கலங்காது",
      "ஞாலம்",
      "கருது",
      "பவர்",
    ],

    english: [
      {
        word: "kaalam",
        variants: ["Kaalam", "Kalam", "Kalaam", "Galam", "Galaam", "Kaalum", "Kaalamh"],
      },
      {
        word: "karudhi",
        variants: ["Karudhi", "Karuthi", "Karudhee", "Garudhi", "Karudheeh"],
      },
      {
        word: "iruppar",
        variants: ["Iruppar", "Irupaar", "Irupar", "Iruppaar", "Eruppar", "Irubar"],
      },
      {
        word: "kalangaadhu",
        variants: ["Kalangaadhu", "Kalangadhu", "Kalangaathu", "Kalangaadhoo", "Galangaadhu", "Kalangathu"],
      },
      {
        word: "gnaalam",
        variants: ["Gnaalam", "Gnalam", "Nyalam", "Gnalaam", "Njaalam", "Jnaalam"],
      },
      {
        word: "karudhu",
        variants: ["Karudhu", "Karuthu", "Karudhoo", "Garudhu", "Karudhuu", "Karuthuu"],
      },
      {
        word: "pavar",
        variants: ["Pavar", "Bhavar", "Pawar", "Paavar", "Pavaru", "Bavar"],
      },
    ],

    englishMeaning:
      "Those who aim to conquer great things wait patiently for the right time.",

    blanks: [0, 1, 2, 3, 4, 5, 6],
  },
];